var touch_odds_x = -1,
	touch_odds_y = -1,
	touch_odds_t = -1,
	touch_odds_tm = null;

function touch_odds_end() {
	touch_odds_x = -1;
	touch_odds_y = -1;
	touch_odds_t = -1;
	$('.odds__tabs .item_act').css({left: ''}).parent().addClass('anim');
}

$(document).ready(function () {

	$('.odds__nav-button').on('click', function () {

		let index = $('.odds__nav-button').index(this) + 1;

		if ($(this).hasClass('odds__nav-button_active')) {
			if ($('.odds__nav-button').length > index) index++;
			else index = 1;
		}

		nextSlide(index, 'odds');

	});

	$('.odds').on('mousedown touchstart', function (e) {
		if ($(window).width() > 890) return;
		if (touch_odds_tm) window.clearTimeout(touch_odds_tm);
		touch_odds_tm = window.setTimeout(touch_odds_end, 1000);
		var touch = e;
		if (e.type == 'touchstart') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		touch_odds_x = touch.pageX;
		touch_odds_y = touch.pageY;
		touch_odds_t = 0;
	}).on('mousemove touchmove', function (e) {
		if (touch_odds_t == 1 || touch_odds_x == -1) return; // top-botom
		if (touch_odds_t == 2) e.preventDefault(); // left-right
		if (touch_odds_t == -1) return; // for mouse
		var touch = e;
		if (e.type == 'touchmove') {
			var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e; //event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : e.originalEvent.touches[0];
		}
		this_x = touch.pageX;
		this_y = touch.pageY;
		if (touch_odds_t == 0) {
			if (Math.abs(this_x - touch_odds_x) > Math.abs(this_y - touch_odds_y) + 2) {
				touch_odds_t = 2;
				e.preventDefault();
			} else if (Math.abs(this_x - touch_odds_x) + 2 < Math.abs(this_y - touch_odds_y)) {
				touch_odds_t = 1;
				return;
			} else {
				return;
			}
		}
		if (touch_odds_tm) window.clearTimeout(touch_odds_tm);
		touch_odds_tm = window.setTimeout(touch_odds_end, 1000);
		if (this_x - touch_odds_x > 50) {
			$('.odds__tabs .item_act').css({left: ''});
			let index = $('.odds__nav-button').index($('.odds__nav-button_active')[0]);
			if (!index) index = $('.odds__nav-button').length;
			nextSlide(index, 'odds');
			touch_odds_end();
			return;
		}
		if (this_x - touch_odds_x < -50) {
			$('.odds__tabs .item_act').css({left: ''});
			let index = $('.odds__nav-button').index($('.odds__nav-button_active')[0]) + 2;
			if ($('.odds__nav-button').length < index) index = 1;
			nextSlide(index, 'odds');
			touch_odds_end();
			return;
		}
		$('.odds__tabs .item_act').css({left: 30 + this_x - touch_odds_x});
	}).on('mouseup', touch_odds_end);

});

